import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { BrandMark } from '@/shared/components/BrandMark';

/**
 * One frame for every sign-in step (login, MFA, password reset, signup,
 * tenant choice): a brand panel on wide screens, the form on the right.
 * The panel sits in the dark theme on purpose (`dark` scopes the tokens).
 */
export function AuthLayout({ children }: { children: ReactNode }): JSX.Element {
  const { t } = useTranslation();
  return (
    <div className="grid min-h-[100dvh] bg-background lg:grid-cols-[minmax(0,5fr)_minmax(0,7fr)]">
      <aside className="dark hidden flex-col justify-between bg-background p-10 text-foreground lg:flex">
        <div className="flex items-center gap-2.5">
          <BrandMark className="size-9" />
          <span className="text-lg font-semibold">{t('brand.short')}</span>
        </div>
        <div className="max-w-sm space-y-3">
          <p className="text-2xl font-semibold leading-snug">{t('auth.layout.headline')}</p>
          <p className="text-sm text-muted-foreground">{t('auth.layout.subline')}</p>
        </div>
        <p className="text-xs text-muted-foreground">{t('footer.copyright')}</p>
      </aside>
      <main className="flex min-w-0 flex-col [&>div]:min-h-0 [&>div]:flex-1">{children}</main>
    </div>
  );
}
